import React from 'react'
import { translate } from 'loankeeper-common/helpers'
import { useDispatch } from 'react-redux'

import { actions as LKModalActions } from '../../shared/LKModal'
import LKRequestButton from '../../shared/LKRequestButton'
import { accEntryOper } from 'src/store/accEntry'
import { AppDispatch } from 'src/store/index.d'

const AuthorizeUnAuthorizeButton = (props) => {
  const dispatch = useDispatch<AppDispatch>()
  const { data, onAuthorize, name, style, action } = props
  const params = {
    ID: data.ID,
    HashSum_EntryID_: data.HashSum_EntryID_,
    OID: data.OID,
    OIDHash: data.HashSum_OID_,
    action,
  }

  return (
    <LKRequestButton
      style={style}
      // APICall={Order.operations}
      // "UPDATED API REQUEST 'acc_entry_oper'"
      APICall={(params) => dispatch(accEntryOper(params))}
      APICallParams={params}
      icon={action === 'auth' ? 'bullet_green' : 'bullet_red'}
      onSuccessActions={[onAuthorize(), LKModalActions.close(name)]}
    >
      {action === 'auth' ? translate('frm_acc_entry_add-cmd_auth') : translate('frm_acc_entry_add-cmd_delauth')}
    </LKRequestButton>
  )
}

export default AuthorizeUnAuthorizeButton
